/**
 * @fileoverview Module for `src/lib/deprecatedConfig.js`.
 */

import axios from 'axios';

let configPromise;

/**
 * @deprecated Use newer config loading APIs as modules migrate off legacy flows.
 *
 * Fetches one app config value from the backend config endpoint, memoized for
 * the current page lifecycle once a request succeeds.
 *
 * @param {string} key - App config key.
 * @returns {Promise<*>} Config value for the requested key.
 */

async function get(key) {
  if (!configPromise) {
    configPromise = axios({
      method: 'GET',
      headers: {},
      url: `${ process.env.REACT_APP_API_URL }/v1/config`,
    })
      .then((configFromAPI) => configFromAPI.data.appConfig)
      .catch((err) => {
        // Let the next call retry instead of failing for the rest of the page's life.
        configPromise = undefined;
        throw err;
      });
  }
  const config = await configPromise;
  return config[key];
}

const deprecatedConfig = {
  get,
};

export default deprecatedConfig;
